import { API } from "../../../utils/api";

export const getStockCategoryList = async (query) => {
  const res = await API.get(`stock-categories?${query}`);
  return res.data.data;
};

export const editStockCategory = async (data) => {
  const { detailsIds, payload } = data;
  const res = await API.put(`stock-categories/${detailsIds}`, payload);
  return res.data;
};

export const saveStockCategory = async (data) => {
  const { payload } = data;
  const res = await API.post("stock-categories", payload);
  return res.data;
};

export const removeStockCategory = async (id) => {
  const res = await API.delete(`stock-categories/${id}`);
  return res.data;
};

export const getStockCategory = async (id) => {
  const res = await API.get(`stock-categories/${id}`);
  return res.data.data;
};
export const sortOrderStockCategory = async (filterreorderedData) => {
  const res = await API.post(`stock-categories/change-display-order`, {
    categories: filterreorderedData,
  });
  return res.data;
};
export const sortOrderStockSubCategory = async ({
  filterItems,
  selectedcategoryId,
}) => {
  const res = await API.post(
    `stock-categories/${selectedcategoryId}/subcategories/change-display-order`,
    {
      subcategories: filterItems,
    },
  );
  return res.data;
};
